import React from 'react';
import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';

export default createReactClass({
  propTypes: {
    onChanged: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
    value: PropTypes.string.isRequired,
  },

  getDefaultProps() {
    return {
      disabled: false,
    };
  },

  handleChanged(event) {
    this.props.onChanged(this.refs.select.value);
  },

  render() {
    const optimizedForOptionElements = [14, 16, 18, 21, 24, 28, 32, 36].map((size) => {
      const sizePx = `${size}px`;

      return <option key={size} value={sizePx}>{sizePx}</option>;
    });

    return (
      <select ref="select" disabled={this.props.disabled} onChange={this.handleChanged} className="form-control input-sm" value={this.props.value}>
        {optimizedForOptionElements}
      </select>
    );
  },
});



// WEBPACK FOOTER //
// ./app/javascript/views/Kits/components/OptimizedForSelect.js